import { useEffect, useRef } from "react";
import { trackFeatureStarted, trackScrolled } from "./analytics";

export function useFeatureStarted(feature, enabled = true, extraParams = {}) {
    const tracked = useRef(false);

    useEffect(() => {
        if (!enabled || tracked.current) return;
        tracked.current = true;
        trackFeatureStarted(feature, extraParams);
        // extraParams intentionally omitted from deps — fire once on mount/enable
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [feature, enabled]);
}

/** Fires scrolled once when the section enters the viewport. */
export function useScrolled(ref, section, enabled = true) {
    const tracked = useRef(false);

    useEffect(() => {
        if (!enabled || tracked.current) return;

        const node = ref.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry?.isIntersecting && !tracked.current) {
                    tracked.current = true;
                    trackScrolled(section);
                    observer.disconnect();
                }
            },
            { threshold: 0.2 }
        );

        observer.observe(node);

        return () => observer.disconnect();
    }, [ref, section, enabled]);
}
